<template>
  <div class="main-content">
    <div style="padding:5px 0">
      <el-button no="1" type="primary" :disabled="!isEdit" @click="addPassengerHandler">{{ $t('SeaExport.Add2') }}</el-button>
      <el-button no="2" type="danger" :disabled="!isEdit" @click="removePassengerHandler">{{ $t('SeaExport.Delete') }}</el-button>
    </div>
    <div class="section grid-wrapper" style="height: 450px">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import * as PartyIdType from '@/class/cargo/model/parameters/PartyIdType'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'TabCustomer',
  props: {
    isShow: { type: Boolean, default: false },
    partyType: { type: String, default: '' },
    isfType: { type: Number, default: null },
    cargoDoc: { type: Object, default: null },
    job: { type: Object, default: null },
    isEdit: { type: Boolean, default: false },
    partyNameList: { type: Array, required: true }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        rowHeight: 32,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor
        },
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      isChineseLanguage: false,
      isfPassenger: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.getItemTitle('Code'),
          headerTooltip: this.$t('SeaExport.Code3'),
          field: 'partyCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('Name'),
          headerTooltip: this.$t('SeaExport.Name'),
          field: 'partyName',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            tagName: 'partyName',
            tagValue: 'partyName',
            options: this.partyNameList,
            selectProps: {
              style: 'width: 100%',
              allowCreate: true,
              filterable: true
            }
          },
          onCellValueChanged: p => {
            this.fillDataField(p)
            this.onCellChange(p)
          },
          valueFormatter: (params) => {
            return params.data ? params.data.partyName : ''
          }
        },
        {
          headerName: this.getItemTitle('ID Type'),
          headerTooltip: this.$t('SeaExport.PartyIDType'),
          field: 'partyIdType',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            tagName: 'name',
            tagValue: 'code',
            options: PartyIdType.Party_Id_Types,
            selectProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('ID Number'),
          headerTooltip: this.$t('SeaExport.DocumentNumber'),
          field: 'partyId',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('County Of Origin'),
          headerTooltip: this.$t('SeaExport.Origin'),
          field: 'countryOrigin',
          width: 200,
          hide: !this.isShow,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'HTSCode',
          field: 'htsCode',
          width: 200,
          hide: !this.isShow,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('Address'),
          headerTooltip: this.$t('SeaExport.Address'),
          field: 'addressLine',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('City'),
          headerTooltip: this.$t('SeaExport.City'),
          field: 'city',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('Area Code'),
          headerTooltip: this.$t('SeaExport.AreaCode'),
          field: 'region',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('State'),
          headerTooltip: this.$t('SeaExport.Province'),
          field: 'subDivisionCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%',
              maxlength: '2'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('Zip'),
          headerTooltip: this.$t('SeaExport.ZIP'),
          field: 'postalCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.getItemTitle('Country'),
          headerTooltip: this.$t('SeaExport.Country'),
          field: 'countryCode',
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            inputProps: {
              style: 'width: 100%',
              maxlength: '2'
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    }
  },
  watch: {
    isEdit(newVal) {
      if (!newVal) {
        this.loadGridDataHandler()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const cacheConfig = cache.config
    this.isChineseLanguage = Number(cacheConfig.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  methods: {
    onShow() {
      this.loadGridDataHandler()
    },
    addPassengerHandler() {
      const isfPassenger = {}
      isfPassenger.isfType = this.isfType
      isfPassenger.customerId = this.job.customerId
      isfPassenger.opOffice = this.job.opOffice
      isfPassenger.partyType = this.partyType
      isfPassenger.opType = 'add'
      this.rowData.push(isfPassenger)
      if (!this.cargoDoc.isfPassenger) {
        this.cargoDoc.isfPassenger = []
      }
      this.cargoDoc.isfPassenger.push(isfPassenger)
    },
    removePassengerHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length > 0) {
        selectedRows.forEach(selectRow => {
          const index = this.rowData.findIndex(row => row === selectRow)
          if (index > -1) {
            const row = this.rowData[index]
            // 直接删除列表元素
            this.rowData.splice(index, 1)
            if (row.uuid) {
              // 标记删除
              row.opType = 'del'
              console.log(this.cargoDoc.isfPassenger)
            } else {
              // 删除实际列表元素
              const i = this.cargoDoc.isfPassenger.findIndex(isf => isf === row)
              if (i > -1) {
                this.cargoDoc.isfPassenger.splice(i, 1)
              }
            }
          }
        })
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    onCellChange(p) {
      if (p.data.uuid) p.data.opType = 'edit'
    },
    loadGridDataHandler() {
      this.rowData = []
      if (this.cargoDoc && this.cargoDoc.isfPassenger) {
        const rowData = []
        for (const passenger of this.cargoDoc.isfPassenger) {
          if (passenger.partyType === this.partyType && passenger.isfType === this.isfType && passenger.opType !== 'del') {
            rowData.push(passenger)
          }
        }
        this.rowData = rowData
      }
    },
    checkModel() {
      const ps = this.rowData
      for (const item of ps) {
        if (StrUtils.isEmpty(item.partyCode)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.CodeCannotBeEmpty')}`)
          return false
        }
        if (StrUtils.isEmpty(item.partyName)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.TheNameCannotBeEmpty')}`)
          return false
        }
        if (StrUtils.isEmpty(item.partyIdType)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.CertificateTypeCannotBeBlank')}`)
          return false
        }
        if (StrUtils.isEmpty(item.partyId)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.IDNumberCannotBeEmpty')}`)
          return false
        }
        if (StrUtils.isEmpty(item.addressLine)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.AddressCannotBeEmpty')}`)
          return false
        }
        if (StrUtils.isEmpty(item.city)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.CityCannotBeEmpty')}`)
          return false
        }
        if (StrUtils.isEmpty(item.countryCode)) {
          this.$message.warning(`【${this.$t('SeaExport.CustomerInformation')}】${this.$t('SeaExport.CountryCannotBeEmpty')}`)
          return false
        }
      }
      return true
    },
    // tab内原列表与变更后的列表进行对比，将原有且被删除的数据加回rowData，传到后台作删除依据
    getTabRowData() {
      // 获取rowData中有值的uuid
      const uuids = this.rowData.filter(row => !!row.uuid).map(row => row.uuid)
      const rowData = [...this.rowData]
      // for (const row of this.originRowData) {
      //   // 原数据不在uuids中则添加删除标记，加回列表中
      //   if (!uuids.includes(row.uuid)) {
      //     row.opType = 'del'
      //     rowData.push(row)
      //   }
      // }
      return rowData
    },
    fillDataField(params) {
      if (params.data) {
        const isfPassenger = params.data
        if (params.newValue) {
          const isf = this.partyNameList.find(row => row.partyName === params.newValue)
          if (isf) {
            isfPassenger.partyCode = isf.partyCode // 代码
            isfPassenger.addressLine = isf.addressLine // 地址
            isfPassenger.postalCode = isf.postalCode // 邮编
            isfPassenger.partyId = isf.partyId // 证件id
            isfPassenger.partyIdType = isf.partyIdType // 证件类型
            isfPassenger.countryCode = isf.countryCode // 国家
            isfPassenger.city = isf.city // 城市
            isfPassenger.subDivisionCode = isf.subDivisionCode // 省（区）
            isfPassenger.region = isf.region // 地区
            isfPassenger.partyName = isf.partyName // 名称
            this.gridOptions.api.refreshCells({ force: true }) // 刷新
          } else { // 手动输入一个不匹配的，需要重新赋值
            isfPassenger.partyName = params.newValue
          }
        } else {
          isfPassenger.partyName = params.newValue
        }
      }
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    }
  }
}
</script>

<style scoped>

</style>
